export const MARGIN_RIGHT = 8;
export const ISLAND_HEIGHT = 34;
